import { createTheme, DEFAULT_THEME, SegmentedControl } from '@mantine/core';
import { produce } from 'immer';

export const theme = createTheme(
  produce(DEFAULT_THEME, (draft) => {
    draft.fontFamily = 'Inter';
    draft.fontFamilyMonospace = 'Geist Mono';
    draft.autoContrast = true;
    draft.defaultRadius = 'xs';
    draft.cursorType = 'pointer';
    draft.primaryColor = 'primary';
    draft.primaryShade = { dark: 8, light: 6 };

    const darkColor = draft.colors.blue[8];
    const darkFactors = [
      [0.9, 0.3],
      [0.8, 0.4],
      [0.7, 0.5],
      [0.6, 0.7],
      [0.45, 0.7],
      [0.4, 0.7],
      [0.35, 0.6],
      [0.3, 0.5],
      [0.25, 0.5],
    ] as const;
    const darkMultipliers: [number, number] = [1, 1];
    draft.colors.dark = [
      '#fff',
      ...darkFactors.map(
        ([lFactor, cFactor]) =>
          `oklch(from ${darkColor} ${lFactor * darkMultipliers[0]} calc(c * ${cFactor * darkMultipliers[1]}) h)`,
      ),
    ] as (typeof draft.colors)[string];
    draft.colors.primary = draft.colors.blue;
    draft.colors.accent = draft.colors.cyan;

    draft.components.SegmentedControl = SegmentedControl.extend({
      defaultProps: {
        color: 'blue',
      },
    });

    draft.other = {
      backgroundVideoDisplay: 'none',
      backgroundImage:
        'radial-gradient(at 80% 80%, var(--mantine-color-dark-7), transparent), radial-gradient(at 50% -20%, #0003 0%, transparent 80%)',
    };
  }),
);
